module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-11-7327ef95463d502f8c0df5d05fc423f2.svg";